import {Component, inject, Input, OnChanges} from '@angular/core';
import {AConst} from '../../../core/a-const.enum';
import {FieldConditionService} from '../../../core/field-condition.service';
import {SectionsContainer} from '../../../core/definitions/sections-container';
import {FieldParameters} from '../../../core/definitions/field-parameters';
import {IfType} from '../../../core/definitions/field-if';
import {MetaField} from '../../../core/definitions/meta-field';
import {BaseModel} from "../../../core/definitions/base-model";

@Component({
    selector: 'app-edit-field-inline-array-fields',
    templateUrl: './edit-field-inline-array-fields.component.html',
    styleUrls: ['./edit-field-inline-array-fields.component.scss'],
    standalone: false
})
export class EditFieldInlineArrayFieldsComponent implements OnChanges {
  // Injections
  private readonly fieldCondition: FieldConditionService = inject(FieldConditionService);

  AConst = AConst;

  @Input() sectionsContainer: SectionsContainer;
  @Input() object: BaseModel;
  @Input() grandParentObject: BaseModel;
  @Input() fields: MetaField[];
  @Input() index: number;
  @Input() parentIndex: number;
  @Input() grandparentIndex: number;

  fieldParameters: FieldParameters;

  ngOnChanges() {
    this.fieldParameters = new FieldParameters();
    this.fieldParameters.sectionsContainer = this.sectionsContainer;
    this.fieldParameters.rootObject = this.sectionsContainer.rootObject || this.object;
    this.fieldParameters.grandParentObject = this.grandParentObject;
    this.fieldParameters.object = this.object;
    this.fieldParameters.edit = true;
    this.fieldParameters.index = this.index;
    this.fieldParameters.parentIndex = this.parentIndex;
    this.fieldParameters.grandparentIndex = this.grandparentIndex;
  }

  canShow(field: MetaField) {
    const show = field.display && field.edit !== 'no' ? field.display : null;
    let res = show === 'yes';
    if (res) {
      this.fieldParameters.field = field;
      res = this.fieldCondition.runIf(IfType.SHOW, this.fieldParameters).result;
    }
    return res;
  }
}
